import { render } from "./StatusSetting.vue?vue&type=template&id=223d5862"
import script from "./StatusSetting.vue?vue&type=script&lang=js"
export * from "./StatusSetting.vue?vue&type=script&lang=js"

import "./StatusSetting.vue?vue&type=style&index=0&id=223d5862&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__